import BaseExercise from './components/BaseExercise/BaseExercise.vue';
import CreateQuiz from './components/CreateQuiz/template.vue';
import BaseExerciseMixin from './js/BaseExerciseMixin';
import Condition from './components/scripts/Condition';
const variables = require('./components/scripts/variables');
import ProblemComponent from './components/ProblemComponent.vue';
import FractionComponent from './components/FractionComponent.vue';
import OperationComponent from './components/operations/OperationComponent.vue';
import LongMultiplication from './components/operations/SimpleMultiplication.vue';
import BoxMultiplication from './components/operations/BoxMultiplication.vue';
import Quiz from './components/scripts/QuizClass'



// Declare install function executed by Vue.use()
export function install(Vue) {
	if (install.installed) return;
	install.installed = true;
	Vue.component('BaseExercise', BaseExercise);
}

// Create module definition for Vue.use()
const plugin = {
	install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}

export default BaseExercise;
export {BaseExercise, BaseExerciseMixin, Condition, variables, ProblemComponent, FractionComponent, Quiz, CreateQuiz, OperationComponent, LongMultiplication, BoxMultiplication};
